export default "__VITE_ASSET__7176ab69__"